import { render, staticRenderFns } from "./RegularContainer.vue?vue&type=template&id=ba0a0662&scoped=true&"
import script from "./RegularContainer.vue?vue&type=script&lang=ts&"
export * from "./RegularContainer.vue?vue&type=script&lang=ts&"
import style0 from "./RegularContainer.vue?vue&type=style&index=0&id=ba0a0662&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0a0662",
  null
  
)

export default component.exports